import { PHONES } from "./constants/phoneCode";

export function parseE164(
  e164: string
): { phoneCode: string; phoneNumber: string } | null {
  if (!e164) return null;

  const normalized = e164.trim();

  const digits = normalized.replace(/\D/g, "");

  const sortedPhones = [...PHONES].sort(
    (a, b) =>
      b.code.replace(/\D/g, "").length - a.code.replace(/\D/g, "").length
  );

  for (const { code } of sortedPhones) {
    const cleanCode = code.replace(/\D/g, "");
    if (digits.startsWith(cleanCode)) {
      return {
        phoneCode: code,
        phoneNumber: digits.slice(cleanCode.length),
      };
    }
  }

  return null;
}
